<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";
	import { isPhase3CaseOrigin } from "src/utils/misc";
	export let data = [];
	export let changeFetchParams;

	let isOpen = false;
	let id = -1;

	function toggle(num) {
		isOpen = !isOpen;
		id = num;
	}

	// handle parent sort event
	function handleSort({ detail: { column, direction } }) {
		changeFetchParams({ sortCol: column, sortDir: direction });
	}

	function navigateToDetails(vehicleId, caseOrigin, status) {
		if (caseOrigin === "Desmond" && status === "Investigating") {
			navigate(`/issues/case-management/${vehicleId}`);
		} else {
			navigate(`/issues/case-management/quotation/${vehicleId}`);
		}
	}
</script>

<CustomTable
	columns={[
		{
			key: "plateNo",
			label: "Vehicle No.",
			type: "link",
			linkBy: "vehicleId",
			linkTo: "/car-management/details/",
		},
		{
			key: "caseNo",
			label: "Case No",
			type: "link",
			linkBy: "id",
			linkTo: "/issues/case-management/quotation/",
		},
		{
			key: "createdAt",
			label: "Incident Date & Time",
			type: "date",
			sortCol: "caseCreatedAt",
		},
		{ key: "status", label: "Status", type: "masterdata" },
		{ key: "damageLocation", label: "Damage Location" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "view",
		},
	]}
	rows={data}
	emptyMessage="There are currently no cases to display."
	on:rowClick={(e) => {
		// get id of row clicked
		id = e.detail.id;
		// open the modal
		isOpen = true;
	}}
	on:sort={handleSort}
/>
